import { RANK_LIST } from '@/mocks/gossip';

export default function HotRank() {
  return (
    <section id="hot" className="border-b border-background-200/70 bg-background-50">
      <div className="mx-auto max-w-7xl px-4 py-10 md:px-6 md:py-14">
        <div className="mb-6 flex flex-col gap-2 sm:flex-row sm:items-end sm:justify-between">
          <div>
            <h2 className="flex items-center gap-2 text-2xl font-bold tracking-wide text-foreground-950 md:text-[1.7rem]">
              <i className="ri-fire-fill text-primary-500" aria-hidden="true" />
              今日瓜类 · 热度榜
            </h2>
            <p className="mt-1.5 text-sm text-foreground-600">
              <b>婚内出轨明星</b>实时的讨论热度，排序每十分钟刷新一次。
            </p>
          </div>
          <span className="inline-flex shrink-0 items-center gap-1.5 rounded-full bg-primary-100 px-3 py-1.5 text-xs font-medium text-primary-800">
            <i className="ri-refresh-line" aria-hidden="true" />
            上次刷新 08-12 23:40
          </span>
        </div>

        <div className="overflow-hidden rounded-xl border border-background-200/70">
          {RANK_LIST.map((r, i) => (
            <button
              key={r.rank}
              type="button"
              className="group flex w-full cursor-pointer items-center gap-4 border-b border-background-200/60 bg-background-50 px-4 py-3 text-left transition-colors last:border-b-0 hover:bg-background-100 md:px-5"
            >
              <span
                className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-md text-sm font-black ${
                  i === 0
                    ? 'bg-accent-500 text-background-50'
                    : i === 1
                      ? 'bg-secondary-300 text-foreground-900'
                      : i === 2
                        ? 'bg-secondary-200 text-foreground-800'
                        : 'bg-background-200 text-foreground-500'
                }`}
              >
                {r.rank}
              </span>
              <span className="font-heading text-xl tracking-[0.15em] text-foreground-950">{r.name}</span>
              <span className="hidden shrink-0 rounded-full bg-primary-100 px-2 py-0.5 text-[11px] text-primary-800 sm:inline">
                {r.word}
              </span>
              <span className="ml-auto flex items-center gap-1.5 text-sm font-bold text-primary-600">
                <span className="hidden text-xs font-normal text-foreground-500 md:inline">热度</span>
                {(r.heat / 1000).toFixed(1)}w
                <i
                  className={`ml-0.5 ${i === 0 ? 'ri-arrow-up-line text-accent-600' : 'ri-arrow-up-line text-secondary-500'}`}
                  aria-hidden="true"
                />
              </span>
            </button>
          ))}
        </div>
      </div>
    </section>
  );
}